//src/app/services/engagementLetters/index.ts
import api, { IGetQueryParams, buildQueryParams } from '../index';

export const engagementLetter = api.injectEndpoints({
  endpoints: (builder) => ({
    getEngagementLetterStats: builder.query<
      {
        engagement_letters_signed_count: number;
        engagement_letters_unsigned_count: number;
        engagement_letters_total_count: number;
      },
      IGetQueryParams<{
        year?: number;
      }>
    >({
      query: (params) => `/engagement_letters/stats${buildQueryParams(params)}`,
    }),

    createEngagementLetter: builder.mutation({
      query: ({ projectId, price }: { projectId: number; price: number }) => ({
        url: `/engagement_letters`,
        method: 'POST',
        body: {
          engagement_letter: {
            amount: price,
            project_id: projectId,
            services: '', //just a dummy 🥺
            end_date: '11-11-2000', //just a dummy 🥺
          },
        },
      }),
    }),
    getEngagementLetter: builder.query<any, string>({
      query: (id) => `engagement_letters/13`,
      providesTags: () => [{ type: 'EngagementLetter' }],
    }),
  }),
});

export const {
  useCreateEngagementLetterMutation,
  useGetEngagementLetterQuery,
  useGetEngagementLetterStatsQuery,
} = engagementLetter;
